import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'iataCassFormatter',
  standalone: false,
})
export class IataCassFormatterPipe implements PipeTransform {
  // @param value: string
  // @param args: any

  transform(value: string, args?: any): string {
    value = value.replace('-', '');
    value = value.replace(' ', '');
    if (value.length > 7) {
      return value.substr(0, 7) + '-' + value.substr(7);
    } else {
      return value;
    }
  }
}
